import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Updatestatus(state = initialState, action) {
  
  switch (action.type) {
    case userConstants.UPDATESTATUSCHANGE_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.UPDATESTATUSCHANGE_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.UPDATESTATUSCHANGE_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}